var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7761 11.057C13.2554 10.5363 12.4112 10.5363 11.8905 11.057C11.3698 11.5777 11.3698 12.4219 11.8905 12.9426L14.9478 15.9999L11.8906 19.0571C11.3699 19.5778 11.3699 20.422 11.8906 20.9427C12.4113 21.4634 13.2555 21.4634 13.7762 20.9427L16.8334 17.8855L19.8905 20.9427C20.4112 21.4634 21.2554 21.4634 21.7761 20.9427C22.2968 20.422 22.2968 19.5777 21.7761 19.057L18.719 15.9999L21.7762 12.9427C22.2969 12.422 22.2969 11.5778 21.7762 11.0571C21.2555 10.5364 20.4113 10.5364 19.8906 11.0571L16.8334 14.1143L13.7761 11.057Z",
    fill: "#B3281D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8333 26.6665C22.7244 26.6665 27.5 21.8909 27.5 15.9998C27.5 10.1088 22.7244 5.33317 16.8333 5.33317C10.9423 5.33317 6.16667 10.1088 6.16667 15.9998C6.16667 21.8909 10.9423 26.6665 16.8333 26.6665ZM16.8333 29.3332C24.1971 29.3332 30.1667 23.3636 30.1667 15.9998C30.1667 8.63604 24.1971 2.6665 16.8333 2.6665C9.46954 2.6665 3.5 8.63604 3.5 15.9998C3.5 23.3636 9.46954 29.3332 16.8333 29.3332Z",
    fill: "#B3281D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToastIcon);
export default __webpack_public_path__ + "static/media/error_toast_icon.88c807618eaa2d94ca62bdd1e64b1996.svg";
export { ForwardRef as ReactComponent };